var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#EBEEF5",
    fillOpacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1089_8150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33331 9.33325V7.99992C9.33331 6.52716 10.5272 5.33325 12 5.33325L16 5.33325C17.4727 5.33325 18.6666 6.52716 18.6666 7.99992V11.9999C18.6666 13.4727 17.4727 14.6666 16 14.6666H14.6666M9.33331 9.33325H7.99998C6.52722 9.33325 5.33331 10.5272 5.33331 11.9999V15.9999C5.33331 17.4727 6.52722 18.6666 7.99998 18.6666H12C13.4727 18.6666 14.6666 17.4727 14.6666 15.9999V14.6666M9.33331 9.33325H12C13.4727 9.33325 14.6666 10.5272 14.6666 11.9999V14.6666",
    stroke: "#4E5362",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1089_8150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.31e52089daac0ad02e4c77bf73995903.svg";
export { ForwardRef as ReactComponent };